import script from "./problem.vue?vue&type=script&setup=true&lang=js"
export * from "./problem.vue?vue&type=script&setup=true&lang=js"

import "./problem.vue?vue&type=style&index=0&id=34b19ebd&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34b19ebd"]])

export default __exports__